import states from './states'
import { UPDATE_DASHBOARD_STATE, LIVE_COUNT_PER_SEC, LIVE_COUNT_PER_MIN, UPDATE_ANALYSIS_DATA } from './actiontypes'

const dashboard_details = (state = states.dashboard_details, action) => {
  switch (action.type) {
    case UPDATE_DASHBOARD_STATE: {
      return {
        ...state,
        ...action.payload
      }
    }

    case LIVE_COUNT_PER_SEC: {
      return {
        ...state,
        live_count: [...action.payload],
        live_traffic_per_sec: state.live_traffic_per_sec.length >= (60 * action.payload.length) ?
          [...state.live_traffic_per_sec.slice(action.payload.length), ...action.payload] :
          [...state.live_traffic_per_sec, ...action.payload],
      }
    }

    case LIVE_COUNT_PER_MIN: {
      return {
        ...state,
        live_traffic_per_min: state.live_traffic_per_min.length >= (60 * action.payload.length) ?
          [...state.live_traffic_per_min.slice(action.payload.length), ...action.payload] :
          [...state.live_traffic_per_min, ...action.payload]
      }
    }

    case UPDATE_ANALYSIS_DATA: {
      const updatedStats = [...state.dashboard_stats]
      const { dataType, data } = action.payload

      data.forEach(newCategory => {
        const existingCategoryIndex = updatedStats.findIndex(
          cat => cat.category === newCategory.category
        )

        if (existingCategoryIndex !== -1) {
          const existingData = [...updatedStats[existingCategoryIndex].data]

          newCategory.data.forEach(newItem => {
            const existingItemIndex = existingData.findIndex(
              item => item.title === newItem.title
            )

            if (existingItemIndex !== -1) {
              if (existingData[existingItemIndex].value !== newItem.value) {
                existingData[existingItemIndex] = {
                  ...existingData[existingItemIndex],
                  value: newItem.value,
                  type: dataType,
                }
              }
            } else {
              existingData.push({
                ...newItem,
                type: dataType,
              })
            }
          })

          updatedStats[existingCategoryIndex] = {
            ...updatedStats[existingCategoryIndex],
            data: existingData,
          }
          
        } else {
          updatedStats.push({
            ...newCategory,
            data: newCategory.data.map(item => ({
              ...item,
              type: dataType,
            })),
          })
        }
      })

      return {
        ...state,
        dashboard_stats: updatedStats,
      }
    }

    default:
      return state
  }
}

export default dashboard_details
